import React, { useEffect, useState } from "react";
import { Modal, Spin, Empty } from "antd";
import { useSelector } from "react-redux";
import { callDanfeByReference } from "../../../services/stockMovementService";
import DanfeContent from "./DanfeContent";
import { callGetInvoiceById } from "../../../services/invoiceService";

/**
 * Visualizador de NF-e (DANFE) — STUB.
 *
 * Recebe a referência da NF e busca a DANFE via callDanfeByReference (stub no
 * POC). Renderiza o mínimo necessário para o botão "Visualizar"/"Ver NF-e".
 * A renderização completa do layout DANFE tem escopo próprio (spec separada).
 */
const DanfeViewerModal = ({ visible, invoiceId, groupId, farmId, onClose }) => {
  const { translation } = useSelector((state) => state.app);
  const viewNfe =
    translation?.stockItem?.movements?.detail?.viewNfe || "Ver NF-e";

  const [loading, setLoading] = useState(false);
  const [danfe, setDanfe] = useState(null);

  useEffect(() => {
    let active = true;
    if (visible && invoiceId) {
      setLoading(true);
      callGetInvoiceById({ groupId, farmId, id: invoiceId })
        .then(({ data }) => {
          if (active) setDanfe(data);
        })
        .catch(() => {
          if (active) setDanfe(null);
        })
        .finally(() => {
          if (active) setLoading(false);
        });
    }
    return () => {
      active = false;
    };
  }, [visible, invoiceId, groupId, farmId]);

  return (
    <Modal
      title={`${viewNfe}${danfe ? ` — ${danfe.numero_nf}` : ""}`}
      visible={visible}
      width={900}
      footer={null}
      onCancel={onClose}
    >
      <Spin spinning={loading}>
        {danfe ? (
          <DanfeContent
            invoice={danfe}
            t={translation?.invoiceUploadViewer.drawer || {}}
          />
        ) : (
          <Empty
            description={
              loading
                ? null
                : "Visualização da DANFE será disponibilizada pelo backend."
            }
          />
        )}
      </Spin>
    </Modal>
  );
};

export default DanfeViewerModal;
